import React from 'react';
import PropTypes from 'prop-types';
import { InputGroup, Input, InputGroupAddon } from 'reactstrap';

export default class ArrayInput extends React.Component {
  constructor() {
    super();
    this.state = {
      value: [''],
      itemIds: [Date.now()],
    };

    this.addItem = this.addItem.bind(this);
    this.removeItem = this.removeItem.bind(this);
  }

  handleChange(e, idx) {
    const updatedValue = e.target.value;
    this.setState(oldState => {
      const newValue = [...oldState.value];
      newValue[idx] = updatedValue;
      this.props.handleChange(newValue);
      return {
        value: newValue,
      };
    });
  }

  addItem() {
    this.setState(oldState => ({
      value: [...oldState.value, ''],
      itemIds: [...oldState.itemIds, Date.now()],
    }));
  }

  removeItem() {
    const lastItemIdx = this.state.value.length - 1;
    if (lastItemIdx < 1) {
      return;
    }
    this.setState(oldState => ({
      value: oldState.value.slice(0, lastItemIdx),
      itemIds: oldState.itemIds.slice(0, lastItemIdx),
    }));
  }

  render() {
    const lastItemIdx = this.state.value.length - 1;
    const inputs = this.state.value
      .slice(0, lastItemIdx)
      .map((value, idx) => (
        <Input
          key={this.state.itemIds[idx]}
          onChange={e => this.handleChange(e, idx)}
          type="text"
          value={value}
        />
      ));
    inputs.push(
      <InputGroup key={this.state.itemIds[lastItemIdx]}>
        <Input
          type="text"
          onChange={e => this.handleChange(e, lastItemIdx)}
          value={this.state.value[lastItemIdx]}
        />
        <InputGroupAddon addonType="append" onClick={this.addItem}>
          +
        </InputGroupAddon>
        <InputGroupAddon addonType="append" onClick={this.removeItem}>
          -
        </InputGroupAddon>
      </InputGroup>,
    );
    return inputs;
  }
}

ArrayInput.propTypes = {
  handleChange: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/FormBuilder/ArrayInput.jsx